/* eslint-disable react/display-name */
import React, { useContext, useState } from 'react'
import Icon from '@ui-components/icon'

import i18n from 'live/services/i18n'
import globalNotification from 'live/services/global-notification'

import * as S from './styled'
import * as T from '../types'
import { AttributesContext } from '../Context/AttributesProvider'

import SearchBar from 'plugin-attributes-manager/shared/components/SearchBar/SearchBar'
import LoadingSpinner from 'plugin-attributes-manager/shared/components/LoadingSpinner/LoadingSpinner'
import GenericList, { Column } from 'plugin-attributes-manager/shared/components/GenericList/GenericList'
import AttributeModal from '../components/AttributeModal/AttributeModal'
import { CalculatorFilled } from '@ant-design/icons'

const Attributes: React.FC = () => {
    const { loading, attributes, derivedQuantities } = useContext(AttributesContext)
    const [filter, setFilter] = useState('')
    const [showModal, setShowModal] = useState(false)
    const [modalName, setModalName] = useState('')
    const [attribute, setAttribute] = useState<T.AttributeList>(undefined)

    const columns: Column<any>[] = [
        { title: 'Name', key: 'name', dataIndex: 'name' },
        { title: 'Description', key: 'description', dataIndex: 'description' },
        {
            title: 'Quantity',
            key: 'quantity',
            dataIndex: 'derivedQuantity.name'
        },
        // { title: 'UOM', key: 'uom', dataIndex: 'uom' },
        // { title: 'Status', key: 'status', dataIndex: 'status' },
        {
            title: '',
            key: 'actions',
            width: 50,
            renderItem: (value, item: T.AttributeList) => {
                return (
                    <>
                        <S.IconContainer>
                            <i
                                className={'far fa-edit'}
                                style={{ fontWeight: 600, fontSize: '14px' }}
                                onClick={event => {
                                    event.stopPropagation()
                                    setModalName(i18n('Edit Attribute'))
                                    setShowModal(true)
                                    setAttribute(item)
                                }}
                            />
                        </S.IconContainer>
                    </>
                )
            }
        }
    ]

    const closeModalFunction = () => {
        setModalName('')
        setAttribute(undefined)
        setShowModal(false)
    }

    return (
        <>
            {loading ? (
                <S.Container>
                    <LoadingSpinner data-testId="loading-bar">{i18n('Loading...')}</LoadingSpinner>
                </S.Container>
            ) : (
                <>
                    <S.Container>
                        <S.Header>
                            <S.TextButton
                                data-testId="attributes_manager-create_attribute-button-newAttribute"
                                onClick={() => {
                                    setModalName(i18n('New Attribute'))
                                    setShowModal(true)
                                }}
                            >
                                <Icon type={'plus-circle'} style={{ fontWeight: 600 }} />
                                {i18n('New Attribute')}
                            </S.TextButton>
                            <SearchBar
                                width={'100%'}
                                filter={filter}
                                setFilter={(term: string) => {
                                    setFilter(term)
                                }}
                            />
                        </S.Header>
                        <GenericList
                            columns={columns}
                            data={attributes ? Array.from(attributes.values()) : []}
                            filterProps={{ term: filter, column: 'name' }}
                            sort={true}
                            onClickRow={() => {}}
                            maxHeight={`calc(100% - 120px)`}
                        ></GenericList>
                    </S.Container>
                    <AttributeModal
                        showModal={showModal}
                        setShowModal={setShowModal}
                        title={modalName}
                        attribute={attribute}
                        onClose={closeModalFunction}
                    ></AttributeModal>
                </>
            )}
        </>
    )
}

export default Attributes
